import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { deserialize } from "utils/storeUtils";
import TemplateGroupRepository from "repositories/TemplateGroupRepository";

const initialState = {
  templateGroup: null,
  recommended: [],
};

const templateGroupSlice = createSlice({
  name: "templateGroup",
  initialState,
  reducers: {
    loadTemplateGroupSuccess(state, { payload }) {
      state.templateGroup = deserialize(payload);
    },
    loadRecommendedTemplateGroupsSuccess(state, { payload }) {
      state.recommended = payload?.map((item) => deserialize({ data: item }));
    },
    clearRecommendedTemplatesGroup(state) {
      state.recommended = [];
    },
    clearTemplateGroupSuccess(state) {
      state.templateGroup = null;
    },
  },
});

export const { actions } = templateGroupSlice;
export default templateGroupSlice.reducer;

export const useTemplateGroupActions = () => {
  const dispatch = useDispatch();

  const loadTemplateGroup = (slug) => {
    return TemplateGroupRepository.show(slug).then(({ data }) => {
      dispatch(templateGroupSlice.actions.loadTemplateGroupSuccess(data));
      return data;
    });
  };

  const loadTemplateGroupFromContentful = (slug, withDraft) => {
    return TemplateGroupRepository.contentfulShow(slug, withDraft).then(({ data }) => {
      dispatch(templateGroupSlice.actions.loadTemplateGroupSuccess(data));
      return data;
    });
  };

  const loadRecommendedTemplatesGroup = (templateGroupId, templateGroupType) => {
    return TemplateGroupRepository.recommendedTemplatesGroup(templateGroupId, templateGroupType)
      .then(({ data }) => {
        dispatch(templateGroupSlice.actions.loadRecommendedTemplateGroupsSuccess(data?.data));
        return data;
      })
      .catch(() => {
        dispatch(templateGroupSlice.actions.clearRecommendedTemplatesGroup());
      });
  };

  const clearRecommendedTemplatesGroup = () => dispatch(templateGroupSlice.actions.clearRecommendedTemplatesGroup());

  const clearTemplateGroup = () => dispatch(templateGroupSlice.actions.clearTemplateGroupSuccess());

  return {
    loadTemplateGroup,
    loadTemplateGroupFromContentful,
    clearTemplateGroup,
    loadRecommendedTemplatesGroup,
    clearRecommendedTemplatesGroup,
  };
};
